import React from 'react';
export function BigIdea() {
  return <section aria-labelledby="bigidea-heading" className="w-full bg-ink" data-id="element-21" data-mp="1vstwp7cd25n7">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center" data-id="element-22" data-mp="2p8x01gh2urrx">
        <h2 id="bigidea-heading" className="font-serif font-normal text-white text-[28px] leading-[1.15] sm:text-[40px] tracking-[-0.01em]" data-id="element-23" data-mp="2u8roldddr59t">
          The difference between a calm wedding and a twelve-month spiral
          isn&apos;t organization.
        </h2>

        <p className="mt-6 font-serif italic text-[34px] sm:text-[52px] leading-none text-sage" data-id="element-24" data-mp="26ixeh3kg3ut9">
          It&apos;s sequence.
        </p>

        <p className="mt-10 text-[17px] sm:text-[18px] leading-[1.6] text-white/75" data-id="element-25" data-mp="2bgyx5ndyls47">
          Organization gives you more lists. Sequence gives you your life back. A
          wedding is two hundred decisions — you can&apos;t pick stationery
          without a date, or a date without a venue, or a venue without a budget
          and a guest count. Everyone hands you the tasks. Nobody hands you the{' '}
          <span className="text-white font-semibold" data-id="element-26" data-mp="2u0zfouc98o68">order</span>.
        </p>

        <div className="mx-auto mt-10 h-px w-24 bg-white/20" aria-hidden="true" data-id="element-27" data-mp="2p3z9mjfenlf4" />

        <p className="mt-10 text-[17px] leading-[1.6] text-white/80" data-id="element-28" data-mp="2kb6acb2ph5af">
          We call it{' '}
          <span className="font-serif italic text-white" data-id="element-29" data-mp="2gb5seggeebym">
            The Runway System™
          </span>{' '}
          — one volume per phase of your runway, so you only ever open the month
          you&apos;re living.
        </p>
      </div>
    </section>;
}